import { render, staticRenderFns } from "./Faqs.vue?vue&type=template&id=6c5531ee&scoped=true"
import script from "./Faqs.vue?vue&type=script&lang=js"
export * from "./Faqs.vue?vue&type=script&lang=js"
import style0 from "./Faqs.vue?vue&type=style&index=0&id=6c5531ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c5531ee",
  null
  
)

export default component.exports